import { TextField } from '@mui/material';
import { getInputDisplay, getMetricSpec } from '@strength/domain-workout';
import { useMetrics } from '../../../../../hooks/useMetrics';
import { DeltaIndicator } from './DeltaIndicator';
import { BaseMetricInputProps } from './types';

/**
 * Allows incrementing/decrementing a set metric by a fixed amount.
 * For numeric metrics without units.
 */
export const RepInput = ({
  workoutSetId,
  setMetric,
  exerciseMetric,
  originalSetMetric,
  onEditSetMetric,
  disabled,
}: BaseMetricInputProps) => {
  const { getMetric } = useMetrics();
  const metric = getMetric(exerciseMetric.metricId);
  const { value, placeholder, delimiter } = getInputDisplay({
    metric,
    prescribedValue: originalSetMetric?.input,
    actualValue: setMetric?.input,
  });

  const spec = getMetricSpec(metric);
  const parsedMetric = spec.schema.safeParse(setMetric?.input);
  const metricDisplayType = parsedMetric.data?.type;

  const repValues = delimiter ? String(value).split(delimiter) : [value];
  const repPlaceholders = delimiter
    ? String(placeholder).split(delimiter)
    : [placeholder];

  return (
    <div className="flex flex-row gap-1">
      {Array.isArray(repValues) &&
        Array.isArray(repPlaceholders) &&
        repValues.map((val, idx) => {
          const metricValue = String(val);
          const metricPrescription = String(repPlaceholders[idx]);
          return (
            <span key={idx} className="flex items-center w-full">
              <TextField
                disabled={disabled}
                value={metricValue}
                placeholder={metricPrescription}
                fullWidth
                InputProps={{
                  sx: {
                    width: '100%',
                    '& input': {
                      minWidth: `${String(val).length}ch`,
                      boxSizing: 'border-box',
                    },
                  },
                  endAdornment: (
                    <DeltaIndicator
                      metric={metric}
                      actual={metricValue}
                      prescribed={metricPrescription}
                    />
                  ),
                  inputMode: 'numeric',
                }}
                onChange={(e) => {
                  const newValue = parseInt(e.target.value) || 0;
                  if (metricDisplayType === 'complex') {
                    const newInput = [...repValues];
                    newInput[idx] = newValue;
                    onEditSetMetric(workoutSetId, {
                      metricId: exerciseMetric.metricId,
                      input: newInput.join(delimiter),
                    });
                  } else {
                    onEditSetMetric(workoutSetId, {
                      metricId: exerciseMetric.metricId,
                      input: String(newValue),
                    });
                  }
                }}
                sx={{ mt: 0 }}
              />
              {/* Add delimiter between fields, except after the last one */}
              {typeof delimiter === 'string' && idx < repValues.length - 1 && (
                <span style={{ margin: '0 4px' }}>{delimiter}</span>
              )}
            </span>
          );
        })}
    </div>
  );
};
